export default [{
  path: '/MaterialVideo',//视频点播
  name: 'VideoPage',
  component: () => import('@/view/Material/VideoDetail.vue'),
  meta: {
    keepAlive: false,
    title:'视频点播_资料中心_中国国际投资贸易洽谈会',
  }
},{
  path: '/MaterialPic',//
  name: 'PicMPage',
  component: () => import('@/view/Material/FileData.vue')
},{
  
  path: '/MaterialHisM',//历届回顾  历届简要回顾
  name: 'HisMPage',
   meta: {
    title:'历届回顾_资料中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Material/HisFileData.vue'),
},{
  path: '/MaterialHisMDet',//历届回顾-详情  历届简要回顾
  name: 'HisDetMPage',
   meta: {
    title:'详情_资料中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Material/HisFileDet.vue'),
},{
  path: '/MaterialPicDet',
  name: 'PicMDetPage',
   meta: {
    title:'资料中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Material/PicDetail.vue')
},{
  path: '/MaterialFile',//资料下载
  name: 'FilePage',
   meta: {
    title:'资料下载_资料中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Material/FileData.vue')
},{
  path: '/MaterialFileData',//资料下载详情
  name: 'FileDataPage',
   meta: {
    title:'资料下载详情_资料中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Material/FileDataDetail.vue')
},{
  path: '/MaterialHistory',
  name: 'HistoryPage',
   meta: {
    title:'资料中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Material/FileData.vue')
},
{
  path: '/MaterialSeaGroup',//历届团组 历届成果表
  name: 'pdfMPage',
   meta: {
    title:'历届团组_资料中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Material/pdf.vue')
},
]




// WEBPACK FOOTER //
// ./src/router/Material.js